import { render, staticRenderFns } from "./applyRecords.vue?vue&type=template&id=3644a70f&scoped=true&"
import script from "./applyRecords.vue?vue&type=script&lang=js&"
export * from "./applyRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3644a70f",
  null
  
)

export default component.exports